<template>
  <div class="pa-admin">
    <!-- design "POP Admin - Authority.html": the six tabs of the section (.subnav) -->
    <div class="paa-subnav" role="tablist">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        role="tab"
        class="paa-subnav__tab"
        :class="{ 'paa-subnav__tab--active': activeTab === tab.key }"
        :aria-selected="activeTab === tab.key ? 'true' : 'false'"
        @click="activeTab = tab.key"
      >{{ tab.label }}</button>
    </div>
    <div class="paa-main">
      <customer-overview v-if="activeTab === 'overview'" />
      <setup-fees-timeline v-else-if="activeTab === 'setup'" />
      <package-invoices-timeline v-else-if="activeTab === 'packages'" />
      <content-orders-timeline v-else-if="activeTab === 'content'" />
      <boosters-timeline v-else-if="activeTab === 'boosters'" />
      <commissions-tracker v-else-if="activeTab === 'commissions' && canViewCommissions" />
    </div>
    <pa-toast />
  </div>
</template>

<script>
import PaToast from '@/components/SitesSingleView/PopAuthority/PaToast.vue'
import BoostersTimeline from './BoostersTimeline.vue'
import CommissionsTracker from './CommissionsTracker.vue'
import ContentOrdersTimeline from './ContentOrdersTimeline.vue'
import CustomerOverview from './CustomerOverview.vue'
import PackageInvoicesTimeline from './PackageInvoicesTimeline.vue'
import SetupFeesTimeline from './SetupFeesTimeline.vue'

const TABS = [
  { key: 'overview', label: 'Customer Overview' },
  { key: 'setup', label: 'Setup Fees Timeline' },
  { key: 'packages', label: 'Package Invoices Timeline' },
  { key: 'content', label: 'Content Orders Timeline' },
  { key: 'boosters', label: 'Boosters Timeline' },
  { key: 'commissions', label: 'Commissions Tracker' },
]

/**
 * Admin > Products > POP Authority. White Glove keeps its own section (Admin/WhiteGlove): POP
 * Authority customers, invoices, orders and commissions are listed here only.
 * `?activeTab=popAuthority&paTab=commissions` opens a tab directly.
 */
export default {
  name: 'AdminPopAuthority',
  components: {
    BoostersTimeline,
    CommissionsTracker,
    ContentOrdersTimeline,
    CustomerOverview,
    PackageInvoicesTimeline,
    PaToast,
    SetupFeesTimeline,
  },
  data () {
    return { activeTab: 'overview' }
  },
  computed: {
    canViewCommissions () {
      const user = this.$store.state.user
      return Boolean(user && user.has_view_access_to_pop_authority_commissions)
    },
    tabs () {
      return TABS.filter((tab) => tab.key !== 'commissions' || this.canViewCommissions)
    },
  },
  mounted () {
    const wanted = this.$route.query.paTab
    if (wanted && this.tabs.some((tab) => tab.key === wanted)) this.activeTab = wanted
  },
}
</script>

<style lang="scss">
@import './paAdmin';
</style>
